module.exports = __webpack_public_path__ + "img/blg.841c11dc.svg";